import { advanceJob } from '../behavior/advanceJob'
import { jobCreators } from '../behavior/jobCreators-sidecar'
import { assignJob } from '../behavior/jobs'
import { jobs } from '../behavior/jobs-sidecar'
import { distance } from '../lib/distance-sidecar'
import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { IMonster } from './monsters'
import { monsters } from './monsters-sidecar'
import { machines } from '../machines/machines-sidecar'
import { machinesData } from '../machines/machinesData-sidecar'
import { machinesDoor } from '../machines/machinesDoor-sidecar'
import { anims } from '../engine/anims-sidecar'
import { machinesAirlock2 } from '../machines/machinesAirlock2-sidecar'
import { monsterMovement } from './monsterMovement-sidecar'

export const update = (monster: IMonster) => {
  // if (monster.team > 0) {
  //   // Player

  // } else {
  //   updateEnemy(monster)
  // }

  updateMonster(monster)
}

const updateMonster = (monster: IMonster) => {
  if (monster.isDying || monster.isDead) {
    return
  }

  // See if we are in combat against slimes

  if (monster.team === 1 && monster.type === 'human') {
    // console.log('checking combat')
    let range = 5
    let dmax = range * range
    let isInCombat = false
    let ms = monsters.getAll()
    for (let i = 0; i < ms.length; i++) {
      let t = ms[i]
      // console.log('checking combat1b', t.type, t.team)
      if (t.team === 0) {
        let d = distance.distanceSquared(t.i, t.j, monster.i, monster.j)
        // console.log('checking combat2')
        // console.log(d)
        if (d < dmax) {
          // Oh! It is close!
          isInCombat = true
          break
        }
      }
    }
    // console.log('isInCombat', isInCombat)
    monsters.setInCombat(monster, isInCombat)
    if (isInCombat) {
      updateAttack(monster, 0)
    }
  }

  if (monster.path.length > 0) {
    monster.idleTimer = 0
    monsterMovement.updateMovement(monster)
    return // moving
  } else {
    monster.currentJob = jobCreators.pruneJob(monster.currentJob)
    if (monster.currentJob === null) {
      // Get a new job ( needs first )
      assignJob(jobCreators.runMulti(monster.jobCreators), monster)

      if (!monster.currentJob) {
        jobs.getRandomJob(monster)
      }

      if (!monster.currentJob) {
        monster.idleTimer++
      }
    } else {
      monster.idleTimer = 0
      advanceJob(monster.currentJob)
    }
  }

  // console.log('job', monster.currentJob)
}

const getTarget = (obj: IMonster, teamNumber: number, maxRange: number = 1) => {
  maxRange += 1
  let maxRangeSquared = maxRange * maxRange

  let target: IMonster | null = null
  let objs = monsters.getAll()
  for (let i = 0; i < objs.length; i++) {
    let c = objs[i]
    if (c.team === teamNumber) {
      if (c.isDead || c.isDying) {
        continue
      }
      // enemy
      // Get distance away
      if (distance.distanceSquaredIJ(obj, c) < maxRangeSquared) {
        target = c
        break
      }
    }
  }
  return target
}

const updateAttack = (obj: IMonster, targetTeam: number) => {
  let delta = common.getUpdateDeltaScaled()

  if (obj.isAttackRecovering) {
    obj.attackRecoverDelay -= delta
    if (obj.attackRecoverDelay <= 0) {
      obj.isAttackRecovering = false
    }
  } else if (obj.isAttacking) {
    obj.attackDelay -= delta
    if (obj.attackDelay <= 0) {
      obj.isAttacking = false
      obj.isAttackRecovering = true
      obj.attackRecoverDelay = obj.data.attackRecoveryDelay

      let t = getTarget(obj, targetTeam, obj.data.range)

      // console.log('attack ??', targetTeam, t, obj.damage, obj.data.range)
      if (t) {
        console.log(
          'attack',
          targetTeam,
          obj.type,
          'vs',
          t.type,
          obj.data.range,
          obj.data.attackDamage,
        )

        monsters.damage(t, obj.damage)
      }
    }
  } else {
    let t = getTarget(obj, targetTeam, obj.data.range)
    if (t) {
      // monsters.playAttackAnimTowards(obj, t.i, t.j)
      obj.isAttacking = true
      obj.attackDelay = obj.data.attackRate
    }
  }
}

// const updateEnemy = (monster: IMonster) => {
//   // if (monster.path.length > 0 || monster.isFindingPath) {
//   //   return // moving or finding
//   // }

//   if (monster.isDying || monster.isDead) {
//     return
//   }

//   let t = getTarget(monster, 1)

//   if (t) {
//     updateAttack(monster, 1)
//   } else if (monster.path.length > 0 || monster.isFindingPath) {
//     updateMovement(monster)
//     return // moving
//   } else {
//     // detect monsters nearby
//     let ctx = scene.getContext()

//     let os = objects.getAllTreasure()

//     // is there treasure here?
//     l.forEach(os, (c) => {
//       if (distance.distanceSquaredIJ(monster, c) < 2 * 2) {
//         objects.kill(c)
//       }
//     })

//     // let treasure = l.sample(os)
//     // if (treasure && !treasure.isDead) {
//     //   monster.isFindingPath = true
//     //   pathFinder.findPath(
//     //     monster.i,
//     //     monster.j,
//     //     treasure.i,
//     //     treasure.j,
//     //     monster.isInsideShip,
//     //     (path) => {
//     //       // console.log('enemy path found!')
//     //       monsters.setPath(monster, path)
//     //       monster.isFindingPath = false
//     //     },
//     //   )
//     // }
//   }

//   // let objs = monsters.getAll()

//   // l.forEach(objs, (c) => {
//   //   if (c.team === 0) {
//   //     // enemy
//   //     // Get distance away
//   //     if (distanceSquared(monster, c) < 2 * 2) {
//   //       // Damage
//   //       monsters.kill(c)
//   //       // Play attack anim
//   //       monsters.playAttackAnimTowards(monster, c.i, c.j)
//   //     }
//   //   }
//   // })
// }
